export default function StringToDate(date) {
    if(!date || date === "" || date === undefined)
    {
        return undefined
    }else
    {
        return new Date(date);
    }
}
